"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function guid(len) {
    if (len === void 0) { len = 8; }
    var g = "";
    for (var i = 0; i < len; i++) {
        g += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length));
    }
    return g;
}
exports.guid = guid;
function raf(fn) {
    return window.requestAnimationFrame(fn);
}
exports.raf = raf;
function caf(id) {
    return window.cancelAnimationFrame(id);
}
exports.caf = caf;
function ric(fn) {
    return window.requestIdleCallback(fn);
}
exports.ric = ric;
function cic(id) {
    return window.cancelIdleCallback(id);
}
exports.cic = cic;
function capitalize(str) {
    return str.replace(/\b\w/g, function (l) { return l.toUpperCase(); });
}
exports.capitalize = capitalize;
function noop() {
    // tslint:disable no-empty
}
exports.noop = noop;
function flatten(arr) {
    if (!arr || !(arr instanceof Array)) {
        return [arr];
    }
    return arr.reduce(function (a, b) { return flatten(a).concat(flatten(b)); }, []);
}
exports.flatten = flatten;
function compact(arr) {
    if (!arr || !(arr instanceof Array)) {
        return [];
    }
    return arr.filter(function (item) { return !!item; });
}
exports.compact = compact;
function getDeltaFromEvent(e) {
    var deltaX = e.deltaX;
    var deltaY = e.deltaY;
    if (typeof deltaX === "undefined" || typeof deltaY === "undefined") {
        // OS X Safari
        deltaX = e.wheelDeltaX / 6;
        deltaY = e.wheelDeltaY / 6;
    }
    if (e.deltaMode && e.deltaMode === 1) {
        // Firefox in deltaMode 1: Line scrolling
        deltaX *= 10;
        deltaY *= 10;
    }
    if (deltaX !== deltaX && deltaY !== deltaY /* NaN checks */) {
        // IE in some mouse drivers
        deltaX = 0;
        deltaY = e.wheelDelta;
    }
    if (e.shiftKey) {
        // reverse axis with shift key
        return [-deltaY, -deltaX];
    }
    return [deltaX, deltaY];
}
exports.getDeltaFromEvent = getDeltaFromEvent;
function getMousePosition(e) {
    return {
        x: e.pageX - (window.scrollX || window.pageXOffset),
        y: e.pageY - (window.scrollY || window.pageYOffset)
    };
}
exports.getMousePosition = getMousePosition;
function getTouchPosition(e) {
    return {
        x: e.touches[0].pageX - (window.scrollX || window.pageXOffset),
        y: e.touches[0].pageY - (window.scrollY || window.pageYOffset)
    };
}
exports.getTouchPosition = getTouchPosition;
function addEventsToDocument(eventMap) {
    if (!eventMap) {
        return;
    }
    Object.keys(eventMap).map(function (key) {
        document.addEventListener(key, eventMap[key], false);
    });
}
exports.addEventsToDocument = addEventsToDocument;
function removeEventsFromDocument(eventMap) {
    if (!eventMap) {
        return;
    }
    Object.keys(eventMap).map(function (key) {
        document.removeEventListener(key, eventMap[key], false);
    });
}
exports.removeEventsFromDocument = removeEventsFromDocument;
function getElementCenterPosition(vertical, element) {
    var rect = element.getBoundingClientRect();
    return vertical ?
        rect.top + (rect.height * 0.5) :
        rect.left + (rect.width * 0.5);
}
exports.getElementCenterPosition = getElementCenterPosition;
function ensureValueInRange(val, _a, inRangeCallback) {
    var max = _a.max, min = _a.min;
    if (val <= min) {
        return min;
    }
    if (val >= max) {
        return max;
    }
    return inRangeCallback ? inRangeCallback(val) : val;
}
exports.ensureValueInRange = ensureValueInRange;
function round(num, decimals) {
    if (!isNaN(parseFloat(num)) && isFinite(num)) {
        var decimalPower = Math.pow(10, decimals);
        return Math.round(parseFloat(num) * decimalPower) / decimalPower;
    }
    return NaN;
}
exports.round = round;
function pauseEvent(e) {
    e.stopPropagation();
    e.preventDefault();
}
exports.pauseEvent = pauseEvent;
function isValueOutOfRange(value, _a) {
    var min = _a.min, max = _a.max;
    return value < min || value > max;
}
exports.isValueOutOfRange = isValueOutOfRange;
function getDisplayName(Component) {
    return Component.displayName || Component.name || "Component";
}
exports.getDisplayName = getDisplayName;
function echo(value) {
    return value;
}
exports.echo = echo;
/* tslint:disable variable-name */
function range(start, stop, step) {
    if (start === void 0) { start = 0; }
    if (stop === void 0) { stop = null; }
    if (step === void 0) { step = 1; }
    var _a;
    var _b = [0, start], _start = _b[0], _stop = _b[1];
    if (stop !== null) {
        _a = [start, stop], _start = _a[0], _stop = _a[1];
    }
    var length = Math.max(Math.ceil((_stop - _start) / step), 0);
    var _range = Array(length);
    for (var idx = 0; idx < length; idx++, _start += step) {
        _range[idx] = _start;
    }
    return _range;
}
exports.range = range;
/* tslint:enable variable-name */
function rem(px, base) {
    if (base === void 0) { base = 10; }
    return px / base;
}
exports.rem = rem;
function toREMString(remUnit) {
    return !isNaN(remUnit) ? remUnit + "rem" : undefined;
}
exports.toREMString = toREMString;
function isInRect(coords, rect) {
    return isInRectXAxis(coords, rect) && isInRectYAxis(coords, rect);
}
exports.isInRect = isInRect;
function isInRectXAxis(coords, rect) {
    return coords.x > rect.left && coords.x < rect.left + rect.width;
}
exports.isInRectXAxis = isInRectXAxis;
function isInRectYAxis(coords, rect) {
    return coords.y > rect.top && coords.y < rect.top + rect.height;
}
exports.isInRectYAxis = isInRectYAxis;
function nodeListToArrayOf(nodeList) {
    return Array.prototype.slice.apply(nodeList);
}
exports.nodeListToArrayOf = nodeListToArrayOf;
function clone(obj) {
    if (!obj) {
        return obj;
    }
    return JSON.parse(JSON.stringify(obj));
}
exports.clone = clone;
function moveElement(arr, oldIndex, newIndex) {
    arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
}
exports.moveElement = moveElement;
function mouseWheelEvent() {
    if (typeof window.onwheel !== "undefined") {
        return "wheel";
    }
    else if (typeof window.onmousewheel !== "undefined") {
        return "mousewheel";
    }
}
exports.mouseWheelEvent = mouseWheelEvent;
function isSpecialKeyActive(e) {
    return (e.altKey || e.ctrlKey || e.shiftKey || e.metaKey);
}
exports.isSpecialKeyActive = isSpecialKeyActive;
function manualWindowScroll() {
    window.addEventListener(mouseWheelEvent(), function (e) {
        if (e.altKey || e.ctrlKey || e.shiftKey) {
            return;
        }
        pauseEvent(e);
        var _a = getDeltaFromEvent(e), deltaX = _a[0], deltaY = _a[1];
        window.scrollTo(window.scrollX + deltaX, window.scrollY + deltaY);
        e.returnValue = false;
        return false;
    }, false);
}
exports.manualWindowScroll = manualWindowScroll;
function setDocumentTitle(title) {
    document.title = title;
}
exports.setDocumentTitle = setDocumentTitle;
function multiWordFilter(actual, expected) {
    if (expected === void 0) { expected = ""; }
    if (expected === "") {
        return true;
    }
    if (!actual) {
        return false;
    }
    var reg = "";
    expected.split(" ").forEach(function (v) {
        v = v.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
        reg += "(?=.*" + v + ")";
    });
    reg = new RegExp(reg, "i");
    return actual.search(reg) > -1;
}
exports.multiWordFilter = multiWordFilter;
function triggerUIEvent(target, name) {
    try {
        var evt = window.document.createEvent("UIEvents");
        evt.initUIEvent(name, true, false, window, 0);
        target.dispatchEvent(evt);
    }
    catch (e) {
    }
}
exports.triggerUIEvent = triggerUIEvent;
function isDefined(subject) {
    return typeof (subject) !== "undefined";
}
exports.isDefined = isDefined;
function isFunction(subject) {
    return typeof (subject) === "function";
}
exports.isFunction = isFunction;
function scrollTo(target, x, y) {
    if (target === void 0) { target = window; }
    if (x === void 0) { x = 0; }
    if (y === void 0) { y = 0; }
    if (!isDefined(target) || !isFunction(target.scrollTo)) {
        return;
    }
    target.scrollTo(x, y);
}
exports.scrollTo = scrollTo;
/* tslint:disable space-before-function-paren only-arrow-functions */
function debounce(func, wait, leading) {
    if (leading === void 0) { leading = false; }
    var timeout;
    return function () {
        var context = this;
        var args = arguments;
        var later = function () {
            timeout = null;
            if (!leading) {
                func.apply(context, args);
            }
        };
        var callNow = leading && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };
}
exports.debounce = debounce;
/**
 * isMobile param
 * we don't need a function here to run the regex since
 * if we are in mobile mode - we are in mobile mode all the time.
 */
exports.isMobile = !!(navigator.userAgent.match(/Android/i)
    || navigator.userAgent.match(/webOS/i)
    || navigator.userAgent.match(/iPhone/i)
    || navigator.userAgent.match(/iPad/i)
    || navigator.userAgent.match(/iPod/i)
    || navigator.userAgent.match(/BlackBerry/i)
    || navigator.userAgent.match(/Windows Phone/i));
function hasWhiteSpace(s) {
    return /\s/g.test(s);
}
exports.hasWhiteSpace = hasWhiteSpace;
function trySplitDelimitedString(s) {
    if (s.includes(",")) {
        return s.split((","));
    }
    else if (s.includes("\n")) {
        return s.split(/[\r\n]+/);
    }
    else if (s.includes("\t")) {
        return s.split(("\t"));
    }
    return [s];
}
exports.trySplitDelimitedString = trySplitDelimitedString;
